
import { Optional } from '@angular/core';
import { MessagerService } from '@farris/ui-messager';
import { LanguageService } from '../languag.service';
import { ServerExceptionEntity } from './types';
import { DeviceAbility } from '../util/device-ability';
import { BsModalRef } from '@farris/ui-modal';
import { FormNotifyService } from '../form-notify.service';
import { FrameContext } from '@farris/devkit';
import moment from 'moment';
/**
 * å¼å¸¸å¤çæ¥å£
 */
export interface IExceptionStrategy {
  handleException(error: ServerExceptionEntity): void;
}


/**
 * å¼å¸¸å¤çåºç±»
 */
export class ExceptionStrategy {
  constructor(
    public messagerService: MessagerService,
    @Optional() public languageService: LanguageService) {
  }
}

/**
 * ä¿¡æ¯çº§å«å¼å¸¸å¤ç
 */
export class InfoExceptionStrategy extends ExceptionStrategy implements IExceptionStrategy {
  constructor(
    messagerService: MessagerService,
    @Optional() languageService: LanguageService) {
    super(messagerService, languageService);
  }

  public handleException(error: ServerExceptionEntity): void {
    if (!error) {
      return;
    }

    this.messagerService.info(error.Message);
  }
}


/**
 * è­¦åçº§å«å¼å¸¸å¤ç
 */
export class WarningExceptionStrategy extends ExceptionStrategy implements IExceptionStrategy {
  constructor(
    messagerService: MessagerService,
    @Optional() languageService: LanguageService) {
    super(messagerService, languageService);
  }

  public handleException(error: ServerExceptionEntity): void {
    if (!error) {
      return;
    }

    this.messagerService.warning(error.Message);
  }
}


/**
 * éè¯¯çº§å«å¼å¸¸å¤ç
 */
export class ErrorExceptionStrategy extends ExceptionStrategy implements IExceptionStrategy {
  private langService: LanguageService = null;
  constructor(
    messagerService: MessagerService,
    @Optional() languageService: LanguageService) {
    super(messagerService, languageService);
    this.langService = languageService;
    if (!this.langService) {
      this.langService = new LanguageService();
    }

  }

  public handleException(error: ServerExceptionEntity): void {
    if (!error) {
      return;
    }

    this.handleErrorLevel(error);
  }

  private handleErrorLevel(error: ServerExceptionEntity): void {
    const exceptionMsg = error.Message || '';
    const date = error.date || new Date();
    const localDate = moment(date).format('YYYY-MM-DD HH:mm:ss');
    const detail = error.Detail || `${error.Message}\r\nåçæ¶é´ï¼${localDate}\r\nè¯¦ç»ä¿¡æ¯ï¼${error.innerMessage}` || '';

    const innerMessage = error.innerMessage || null;
    let bsModalRef: BsModalRef;
    const options = {
      // title: this.languageService.serverNotifyTitle,
      showMaxButton: false,
      buttons: [
        {
          text: this.langService.roger,
          cls: 'btn btn-primary btn-lg',
          handle: () => {
            bsModalRef.close();
          }
        }
      ],
      // showHeader: false,
      width: 440,
      height: 200,
      safeHtml: false,
      exception: {
        date: localDate,
        message: innerMessage,
        copyButton: {
          text: this.langService.copy,
          onClick: (e) => {
            const result = DeviceAbility.copyToClipboard(detail);
            const text = result ? this.langService.copySuccess : this.langService.copyFailed;
            bsModalRef.content.showMiniNotify(text, 1500);
          }
        }
      }
    };
    this.displayError(error);
    bsModalRef = this.messagerService.show('exception', exceptionMsg, options);
  }
  /**
   * å¨æ§å¶å°ä¸­æ¾ç¤ºéè¯¯ä¿¡æ¯
   */
  private displayError(error: ServerExceptionEntity) {
    if (!error) {
      return;
    }
    if (!console || !console.error) {
      return;
    }
    console.error(error);
  }
}

/**
 * è´å½éè¯¯çº§å«å¼å¸¸å¤ç
 */
export class FatalExceptionStrategy extends ExceptionStrategy implements IExceptionStrategy {
  constructor(
    messagerService: MessagerService,
    @Optional() languageService: LanguageService) {
    super(messagerService, languageService);
  }

  public handleException(error: ServerExceptionEntity): void {
    if (!error) {
      return;
    }

    this.messagerService.error(error.Message);
  }
}
